var _rect, _path, _rect2, _path2, _g, _path3, _path4, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDv360DisplayAdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.23492,
    y: 13.2349,
    width: 67.5302,
    height: 52.5302,
    rx: 1.76508,
    fill: "white",
    stroke: "#26245B",
    strokeWidth: 0.469841
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C7 14.4477 7.44772 14 8 14H72C72.5523 14 73 14.4477 73 15V22H7V15Z",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 16,
    width: 43,
    height: 4,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 16H61.2381C61.6589 16 62 16.3411 62 16.7619V19.2381C62 19.6589 61.6589 20 61.2381 20H58V16Z",
    fill: "#F5C076"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5734_20340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3424 18.1181C60.6168 17.7306 60.525 17.1941 60.1376 16.9198C59.7502 16.6455 59.2137 16.7372 58.9393 17.1247C58.665 17.5122 58.7567 18.0486 59.1442 18.3229C59.4208 18.5187 59.7864 18.5338 60.0781 18.3615L60.7118 18.9915C60.7803 19.0635 60.8941 19.0664 60.9662 18.998C61.0382 18.9296 61.0411 18.8157 60.9727 18.7437C60.9706 18.7414 60.9685 18.7393 60.9662 18.7371L60.3424 18.1181ZM59.6404 18.1768C59.3342 18.1769 59.086 17.9288 59.0858 17.6227C59.0857 17.3165 59.3337 17.0683 59.64 17.0681C59.9457 17.068 60.1938 17.3156 60.1944 17.6214C60.1949 17.9277 59.9471 18.1763 59.6408 18.1768C59.6406 18.1768 59.6406 18.1768 59.6404 18.1768Z",
    fill: "#555555"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 56.2289C17 56.1025 17.1025 56 17.2289 56H30.7711C30.8975 56 31 56.1025 31 56.2289V65H17V56.2289Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56.2289C33 56.1025 33.1025 56 33.2289 56H47.7711C47.8975 56 48 56.1025 48 56.2289V65H33V56.2289Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56.2289C49 56.1025 49.1025 56 49.2289 56H63.7711C63.8975 56 64 56.1025 64 56.2289V65H49V56.2289Z",
    fill: "#E5E5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5098,
    y: 52.0215,
    width: 11.6681,
    height: 0.915148,
    rx: 0.228787,
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7988,
    y: 53.623,
    width: 7.0924,
    height: 0.915148,
    rx: 0.228787,
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8125,
    y: 44.0449,
    width: 37.0635,
    height: 4.57574,
    rx: 0.228787,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 39.8089,
    height: 14.8712,
    rx: 0.228787,
    fill: "#E5E5E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5234,
    y: 26,
    width: 20.7052,
    height: 14.8712,
    rx: 0.228787,
    fill: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5734_20340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.28571,
    height: 2.28571,
    fill: "white",
    transform: "translate(58.7617 16.7617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDv360DisplayAdsIcon);
export default __webpack_public_path__ + "static/media/dv360-display-ads-icon.310d9da1bf6307ee9bbde1522b8be00d.svg";
export { ForwardRef as ReactComponent };